import styled from 'styled-components';

export const WhiteBox = styled.div`
  padding: 35px;
  border-radius: 10px;
  background-color: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);

  @media (max-width: 420px) {
    padding: 20px 18px;
  }
`;
